import Swal from "sweetalert2";
import HelperMixin from '../../Shared/HelperMixin.vue';
import PaginationHelper from '../../Shared/PaginationHelper.vue';

export default {
    name: 'ScheduledTrips',
    mixins: [HelperMixin],
    components: {
        PaginationHelper
    },

    async created() {
        this.loginDetails = await this.CheckLoginStatus();

        if (!this.requireUserType([1])) return;

        this.GetInfo(this.pageNo);
    },

    computed: {
        totalPages() {
            return Math.ceil(this.pages / this.pageSize);
        }
    },

    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            Search: '',
            StatusFilter: null,
            LevelsFilter: null,
            DateFrom: null,
            DateTo: null,

            ScreenTitle: 'الرحلات المجدولة',
            ScreenTitleSingle: 'رحلة مجدولة',
            ScreenTitleSingleAl: 'الرحلة المجدولة',

            Info: [],
            Statistics: [],
            SelectedItem: null,
            ViewDialog: false,
            TripDetails: null,

            state: 0,
            activeTab: 'details',
            
            TripCategory: null,
            TripChats: [],
            TripDriverCandidates: [],
            TripLevels: [],
            TripRatings: [],
            TripPassenger: null,

            assignDriverForm: {
                DriversId: null,
                VehiclesId: null
            },
            AllDrivers: [],
            DriverVehicles: []
        };
    },

    methods: {
        applyFilters() {
            this.pageNo = 1;
            this.GetInfo(this.pageNo);
        },

        clearDates() {
            this.DateFrom = null;
            this.DateTo = null;
            this.applyFilters();
        },

        GetInfo(pageNo) {
            this.pageNo = pageNo;
            if (this.pageNo === undefined) {
                this.pageNo = 1;
            }

            if (!this.Search)
                this.$blockUI.Start();

            // Format datetime using ChangeDateTimeToISO from HelperMixin
            const dateFrom = this.DateFrom ? this.ChangeDateTimeToISO(this.DateFrom) : '';
            const dateTo = this.DateTo ? this.ChangeDateTimeToISO(this.DateTo) : '';
            const status = this.StatusFilter || '';
            const levels = this.LevelsFilter || '';

            this.$http.GetScheduledTrips(this.pageNo, this.pageSize, this.Search, status, levels, dateFrom, dateTo)
                .then(response => {
                    if (!this.Search)
                        this.$blockUI.Stop();

                    this.Info = response.data.info;
                    this.pages = response.data.count;
                    this.Statistics = response.data.statistics;
                })
                .catch(() => {
                    if (!this.Search)
                        this.$blockUI.Stop();
                    this.pages = 0;
                });
        },

        ViewInfo(item) {
            this.SelectedItem = item;
            this.state = 1;
            this.activeTab = 'details';
            this.GetTripDetails(item.id);
        },

        GetTripDetails(tripId) {
            this.$blockUI.Start();
            this.$http.GetTripById(tripId)
                .then(response => {
                    this.$blockUI.Stop();
                    this.TripDetails = response.data;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.TripDetails = null;
                });
        },

        CancelTrip(item) {
            Swal.fire({
                title: 'تأكيد إلغاء الرحلة',
                text: 'هل أنت متأكد من إلغاء هذه الرحلة؟',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'نعم، إلغاء الرحلة',
                cancelButtonText: 'إلغاء'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.CancelTrip(item.id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo(this.pageNo);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            let msg = err.response && err.response.data ? err.response.data : 'خطأ';
                            this.$helper.ShowMessage('error', 'خطأ', msg);
                        });
                }
            });
        },

        getTripTypeText(type) {
            const types = {
                1: 'مجدولة',
                2: 'مشتركة',
                3: 'مدرسية'
            };
            return types[type] || 'غير معروف';
        },

        getTripTypeClass(type) {
            const classes = {
                1: 'bg-primary-subtle text-primary',
                2: 'bg-info-subtle text-info',
                3: 'bg-warning-subtle text-warning'
            };
            return classes[type] || 'bg-secondary-subtle text-secondary';
        },

        getLevelText(level) {
            const levels = {
                1: 'قيد الانتظار',
                2: 'تم القبول',
                3: 'وصل السائق',
                4: 'بدأت الرحلة',
                5: 'مكتملة',
                6: 'ملغاة'
            };
            return levels[level] || 'غير معروف';
        },

        getLevelClass(level) {
            const classes = {
                1: 'bg-warning-subtle text-warning',
                2: 'bg-info-subtle text-info',
                3: 'bg-primary-subtle text-primary',
                4: 'bg-primary-subtle text-primary',
                5: 'bg-success-subtle text-success',
                6: 'bg-danger-subtle text-danger'
            };
            return classes[level] || 'bg-secondary-subtle text-secondary';
        },

        getStatusText(status) {
            return status === 1 ? 'نشط' : 'غير نشط';
        },

        getStatusClass(status) {
            return status === 1 ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger';
        },

        BackToList() {
            this.state = 0;
            this.SelectedItem = null;
            this.TripDetails = null;
            this.activeTab = 'details';
        },

        switchTab(tab) {
            this.activeTab = tab;
            
            if (!this.TripDetails) return;

            if (tab === 'passenger' && !this.TripPassenger) {
                this.GetTripPassenger(this.TripDetails.id);
            } else if (tab === 'category' && !this.TripCategory) {
                this.GetTripCategory(this.TripDetails.id);
            } else if (tab === 'chats' && this.TripChats.length === 0) {
                this.GetTripChats(this.TripDetails.id);
            } else if (tab === 'levels' && this.TripLevels.length === 0) {
                this.GetTripLevels(this.TripDetails.id);
            } else if (tab === 'ratings' && this.TripRatings.length === 0) {
                this.GetTripRatings(this.TripDetails.id);
            }
        },

        GetTripPassenger(tripId) {
            this.$blockUI.Start();
            this.$http.GetTripPassenger(tripId)
                .then(response => {
                    this.$blockUI.Stop();
                    this.TripPassenger = response.data;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });
        },

        GetTripCategory(tripId) {
            this.$blockUI.Start();
            this.$http.GetTripCategory(tripId)
                .then(response => {
                    this.$blockUI.Stop();
                    this.TripCategory = response.data;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });
        },

        GetTripChats(tripId) {
            this.$blockUI.Start();
            this.$http.GetTripChats(tripId)
                .then(response => {
                    this.$blockUI.Stop();
                    this.TripChats = response.data;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });
        },

        GetTripLevels(tripId) {
            this.$blockUI.Start();
            this.$http.GetTripLevels(tripId)
                .then(response => {
                    this.$blockUI.Stop();
                    this.TripLevels = response.data;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });
        },

        GetTripRatings(tripId) {
            this.$blockUI.Start();
            this.$http.GetTripRatings(tripId)
                .then(response => {
                    this.$blockUI.Stop();
                    this.TripRatings = response.data;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });
        },

        onPageSizeChanged(newSize) {
            this.pageSize = newSize;
            this.pageNo = 1;
            this.GetInfo(this.pageNo);
        },

        OpenAssignDriverModal(item) {
            this.SelectedItem = item;
            this.assignDriverForm.DriversId = null;
            this.assignDriverForm.VehiclesId = null;
            this.DriverVehicles = [];
            this.GetAllDrivers();
        },

        GetAllDrivers() {
            this.$blockUI.Start();
            this.$http.GetAllDrivers()
                .then(response => {
                    this.$blockUI.Stop();
                    this.AllDrivers = response.data.info || [];
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.AllDrivers = [];
                });
        },

        onDriverChange() {
            if (this.assignDriverForm.DriversId) {
                this.GetDriverVehicles(this.assignDriverForm.DriversId);
            } else {
                this.DriverVehicles = [];
                this.assignDriverForm.VehiclesId = null;
            }
        },

        GetDriverVehicles(driverId) {
            this.$blockUI.Start();
            this.$http.GetDriverVehicles(driverId)
                .then(response => {
                    this.$blockUI.Stop();
                    this.DriverVehicles = response.data.info || [];
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.DriverVehicles = [];
                });
        },

        submitAssignDriver() {
            if (!this.assignDriverForm.DriversId) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'يرجى اختيار السائق');
                return;
            }

            this.$blockUI.Start();
            this.$http.AssignDriverToTrip(this.SelectedItem.id, this.assignDriverForm)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                    document.querySelector('[data-bs-dismiss="modal"]').click();
                    this.GetInfo(this.pageNo);
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    let msg = err.response && err.response.data ? err.response.data : 'خطأ';
                    this.$helper.ShowMessage('error', 'خطأ', msg);
                });
        }
    }
};
